import { FormItem } from '..';
import SimpleSelect from './simple-select';
import PropTypes from 'prop-types';

class PrefectureSelect extends SimpleSelect {
  static propTypes = FormItem.extendPropTypes({
    placeholder: PropTypes.string,
    className:   PropTypes.string
  });
  options = [];
  getOptions () {
    const self = this;
    if (typeof YubinBango !== 'undefined' && YubinBango.Core && self.options.length < 1) {
      self.options = new YubinBango.Core().REGION.filter((v) => v);
    }
    return self.options;
  }
}
export default PrefectureSelect;
